import { IDetalleSeguimientoPasstModel, ISeguimientoPasstModel } from "../interfaces/passt/ISeguimientoPasstModel";

export class SeguimientoPasstModel implements ISeguimientoPasstModel{
    name: string;
    children?: Array<SeguimientoPasstModel>;
    data?: Array<DetalleSeguimientoPasstModel>
    constructor(){
        this.name = '';
    }
}

export class DetalleSeguimientoPasstModel implements IDetalleSeguimientoPasstModel{
    idPasstActividad: number;
    actividad?: string;
    eneroProgramado?: string;
    febreroProgramado?: string;
    marzoProgramado?: string;
    abrilProgramado?: string;
    mayoProgramado?: string;
    junioProgramado?: string;
    julioProgramado?: string;
    agostoProgramado?: string;
    setiembreProgramado?: string;
    octubreProgramado?: string;
    noviembreProgramado?: string;
    diciembreProgramado?: string;
    editable: boolean;
    eneroEditable?: boolean;
    febreroEditable?: boolean;
    marzoEditable?: boolean;
    abrilEditable?: boolean;
    mayoEditable?: boolean;
    junioEditable?: boolean;
    julioEditable?: boolean;
    agostoEditable?: boolean;
    setiembreEditable?: boolean;
    octubreEditable?: boolean;
    noviembreEditable?: boolean;
    diciembreEditable?: boolean;
    idEstadoEnero?: number;
    idEstadoFebrero?: number;
    idEstadoMarzo?: number;
    idEstadoAbril?: number;
    idEstadoMayo?: number;
    idEstadoJunio?: number;
    idEstadoJulio?: number;
    idEstadoAgosto?: number;
    idEstadoSetiembre?: number;
    idEstadoOctubre?: number;
    idEstadoNoviembre?: number;
    idEstadoDiciembre?: number;
    eneroEjecutado?: string;
    febreroEjecutado?: string;
    marzoEjecutado?: string;
    abrilEjecutado?: string;
    mayoEjecutado?: string;
    junioEjecutado?: string;
    julioEjecutado?: string;
    agostoEjecutado?: string;
    setiembreEjecutado?: string;
    octubreEjecutado?: string;
    noviembreEjecutado?: string;
    diciembreEjecutado?: string;
    comentarios?: string;
    mesReprogramado?: number;
    puedeEliminar:boolean;
    puedeSolicitar:boolean;
    idEstadoModificacion:number

    mesReprogramadoEnero?: number;
    mesReprogramadoFebrero?: number;
    mesReprogramadoMarzo?: number;
    mesReprogramadoAbril?: number;
    mesReprogramadoMayo?: number;
    mesReprogramadoJunio?: number;
    mesReprogramadoJulio?: number;
    mesReprogramadoAgosto?: number;
    mesReprogramadoSetiembre?: number;
    mesReprogramadoOctubre?: number;
    mesReprogramadoNoviembre?: number;
    mesReprogramadoDiciembre?: number;

    comentarioEnero?: string;
    comentarioFebrero?: string;
    comentarioMarzo?: string;
    comentarioAbril?: string;
    comentarioMayo?: string;
    comentarioJunio?: string;
    comentarioJulio?: string;
    comentarioAgosto?: string;
    comentarioSetiembre?: string;
    comentarioOctubre?: string;
    comentarioNoviembre?: string;
    comentarioDiciembre?: string;

    anio:number;
    idSede:number;
    sede?:string
    constructor(){
        this.idPasstActividad = 0;
        this.editable = false;
        this.puedeEliminar = false;
        this.puedeSolicitar = false;
        this.anio = 0;
        this.idSede = 0;
        this.editable = false;
        this.idEstadoModificacion = 0;

    }
}